module.exports = __webpack_public_path__ + "media/images/emblems/Steinhausen_Wappen-118341b15da85acdac71bcd874cc851e.svg";